import { combineReducers } from '@reduxjs/toolkit';
import loading from './loading';
import toast from './toast';
import flow from './flow';
import auth from './auth';
import affiliate from './affiliate';
import admin from './admin';

export default combineReducers({
  loading,
  toast,
  flow,
  auth,
  affiliate,
  admin
});
